// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration=staging` replaces `environment.ts` with `environment.staging.ts`.
// `ng build --configuration=production` replaces `environment.ts` with `environment.prod.ts`.
// `ng serve --configuration=local` replaces `environment.ts` with `environment.local.ts`.
// The default `development` configuration uses this file as-is.
// The list of file replacements can be found in project.json.

import { SIGNAL } from "@angular/core/primitives/signals";

export const environment = {
  production: false,
  environmentName: 'development', // Default to dev environment
  firebase: {
    apiKey: "AIzaSyBQmfi-2iGBa1FcwueXeHfQWnoDLwwkxtw",
    authDomain: "zopstores-6715e.firebaseapp.com",
    projectId: "zopstores-6715e",
    storageBucket: "zopstores-6715e.appspot.com",
    messagingSenderId: "539681618321",
    appId: "1:539681618321:web:e305b0f054672f0f644230",
    measurementId: "G-BYR5MJB5TM"
  },
  api: {
    baseUrl: 'https://zopup-api-gateway.proudpond-04edd507.centralus.azurecontainerapps.io',
    endpoints: {
      // Main app API endpoints - explicit domain mapping
      audit: 'https://zopup-audit-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      brands: 'https://zopup-brands-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      companies: 'https://zopup-companies-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      contacts: 'https://zopup-contacts-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      currencies: 'https://zopup-currencies-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      customers: 'https://zopup-customers-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      devices: 'https://zopup-devices-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      documents: 'https://zopup-documents-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      finance: 'https://zopup-finance-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      infrastructure: 'https://zopup-infrastructure-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      inventory: 'https://zopup-inventory-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      notifications: 'https://zopup-notifications-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      locations: 'https://zopup-locations-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      productCatalogue: 'https://zopup-product-catalogue-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      reporting: 'https://zop-reporting-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      sales: 'https://zopup-sales-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      scheduler: 'https://zopup-scheduler-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      settings: 'https://zopup-settings-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      subscriptions: 'https://zopup-subscriptions-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      tasks: 'https://zopup-tasks-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      tax: 'https://zopup-tax-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      users: 'https://zopup-users-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      vendors: 'https://zopup-vendors-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      verified: 'https://zopup-verified-api.proudpond-04edd507.centralus.azurecontainerapps.io',
    }
  }
};


// http://localhost:6135%22,%22severitylevel%22:%22information%22,%22properties%22:%7B%22messagetemplate%22:%22now/
//     documents: 'https://zopup-documents-api.proudpond-04edd507.centralus.azurecontainerapps.io',

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
